<template>
    <main-layout class="bg-gray-100 min-h-screen flex flex-col">

        <!-- En-tête + CTA sur fond dégradé -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <div class="p-2 mb-5">
                <app-header icon="tools" class="text-white">
                    <div class="flex items-center justify-between">
                        <h1 class="text-2xl font-semibold tracking-wide">Intervention</h1>
                    </div>
                </app-header>
            </div>
        </div>
        <div
            class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28">
            <form class="mx-1 my-2 mb-40 shadow-2xl rounded-2xl overflow-hidden" @submit.prevent="sendFormFi">
                <div class="p-4 space-y-4 bg-white">
                    <div>
                        <label class="label">Vos références si besoin (N° de bon, initiales tech, etc..)</label>
                        <input title="ref" type="text" class="dossier input" name="ordre_travail" value=""
                            v-model="fibsdd.ordre_travail" maxlength="255" placeholder="Facultatif">
                    </div>
                    <div>
                        <label class="label">Numéro de fiche FI</label>
                        <input type="text" class="dossier input" placeholder="Généré automatiquement si non renseigné"
                            name="numFiche" value="" v-model="fibsdd.numero" maxlength="255">
                    </div>

                    <div id="choice-detenteur">

                        <h2 class="text-lg font-medium mb-5 uppercase text-secondary">DÉTENTEUR</h2>

                        <div v-if="!fromDetOrInst">
                            <label class="label" for="id_detenteur">Nom <span class="text-alert">*</span></label>
                            <v-select
                                class="block w-full rounded border-1 border-gray-300 focus:outline-none focus:border-secondary focus:ring focus:ring-secondary bg-white"
                                id="id_detenteur" ref="selectDet" :filterable="false" :on-change="loadInstallations"
                                :options="detenteursFiltred" @search="onSearch" @change="onChange">
                            </v-select>
                        </div>
                        <div v-else>
                            <label class="label">Détenteur : <span>{{ detString }}</span></label>
                        </div>

                        <div class="mt-4 space-y-2">
                            <div class="flex items-center gap-2">
                                <label class="label !mb-0">Adresse :</label>
                                <span v-if="detSelected" v-text="detSelected.adresse"
                                    class="text-secondary font-bold"></span>
                            </div>

                            <div class="flex items-center gap-2">
                                <label class="label !mb-0">Code postal :</label>
                                <span v-if="detSelected" v-text="detSelected.code_postal"
                                    class="text-secondary font-bold"></span>
                            </div>

                            <div class="flex items-center gap-2">
                                <label class="label !mb-0">Ville :</label>
                                <span v-if="detSelected" v-text="detSelected.ville"
                                    class="text-secondary font-bold"></span>
                            </div>

                            <div class="flex items-center gap-2">
                                <label class="label !mb-0">SIRET :</label>
                                <span v-if="detSelected" v-text="detSelected.siret"
                                    class="text-secondary font-bold"></span>
                            </div>
                        </div>
                    </div>

                    <div id="choice-install" style="display: none;">

                        <h2 class="text-lg font-medium mb-5 uppercase text-secondary">INSTALLATION</h2>

                        <label class="label">Identification <span class="text-alert">*</span></label>
                        <div class="skin-select">
                            <select class="input" @change="loadInstallInfos" v-model="fibsdd.installation"
                                :value="fibsdd.installation">
                                <option selected disabled>Choisissez une installation</option>
                                <option v-for="installation in installations" :key="installation.id"
                                    :value="installation.id">
                                    {{ installation.nom }}
                                    {{ (installation.marque) ? ' - ' + installation.marque : '' }}
                                    {{ (installation.modele) ? ' - ' + installation.modele : '' }}
                                </option>
                            </select>
                        </div>

                        <div v-show="instSelected.hasOwnProperty('charge') && instSelected.fluide !== null"
                            class="mt-4 space-y-2">

                            <div class="flex items-center gap-2">
                                <label class="label !mb-0">Nature du fluide frigorigène :</label>
                                <span v-if="instSelected.fluide" v-text="instSelected.fluide.nom"
                                    class="text-secondary font-bold"></span>
                                <input v-if="instSelected.fluide" type="hidden" name="id_fluide_installation"
                                    id="id_fluide_installation" v-model="fibsdd.fluide_init">
                            </div>

                            <div class="flex items-center gap-2">
                                <label class="label !mb-0">Charge totale (Kg) :</label>
                                <span v-if="instSelected" v-text="instSelected.charge"
                                    class="text-secondary font-bold"></span>
                                <input type="hidden" name="charge_init" id="charge_init" v-model="fibsdd.charge_init">
                            </div>

                            <div class="flex items-center gap-2" v-show="instSelected.hasOwnProperty('detecteur')">
                                <label class="label !mb-0">Présence d'un détecteur de fuite fixe :</label>
                                <span class="text-secondary font-bold">
                                    {{ instSelected.detecteur === true ? 'Oui' : 'Non' }}
                                </span>
                            </div>

                            <div class="flex items-center gap-2">
                                <label class="label !mb-0">
                                    Tonnage équivalent CO<span class="smallexp">2</span> :
                                </label>
                                <span v-if="instSelected" v-text="instSelected.tonnage"
                                    class="text-secondary font-bold"></span>
                            </div>

                            <div class="flex items-center gap-2" v-show="instSelected.frequence_controle">
                                <label class="label !mb-0">Fréquence des contrôles :</label>
                                <span class="text-secondary font-bold"
                                    v-text="instSelected.frequence_controle + ' Mois'"></span>
                            </div>
                        </div>
                    </div>

                    <button class="btn-primary" ref="formButton" name="newFiche">
                        <i class="icon-add"></i>
                        <strong>Ajouter </strong>l'intervention
                    </button>
                </div>
            </form>
        </div>
    </main-layout>
</template>

<script>
import Detenteur from '../../../js/models/Detenteur'
import Installation from '../../../js/models/Installation'
import Fibsdd from '../../../js/models/Fibsdd'

import vSelect from 'vue-select'

export default {
    data() {

        return {

            fibsdd: {

                numero: null,
                ordre_travail: null,
                detenteur: null,
                installation: null,
                charge_init: null,
                fluide_init: null,
                detecteur: null,
                cloture: false,

                natures: {
                    assemblage: false,
                    miseEnService: false,
                    modification: false,
                    maintenance: false,
                    controlePeriodique: false,
                    controleNonPeriodique: false,
                    demantelement: false,
                    retrofit: false,
                    newFluide: null,
                    autres: null,
                    observations: null,
                    description: null,
                    contractuel: null
                },

                ctrlEtanch: {
                    no_fuites: null,
                },

                informations: {
                    temps_deplacement: null,
                    temps_intervention: null,
                    heure_arrivee: null,
                    heure_depart: null,
                    kilometrage: null,
                    desc_pieces: null,
                    observations: null,
                    techs: null,
                    namesTechniciens: null,
                    finish: null,
                    garantie: null,
                    fromDevis: null,
                    needDevis: null,
                    preventif: null,
                    correctif: null,
                    travauxEffectues: null,
                },

                photos: [],

                pieces: [],

                infosDet: {
                    nom_signataire: null,
                    fonction_signataire: null,
                    signature_signataire: null,
                },

            },

            selected: null,
            detenteursOpt: [],
            detenteursFiltred: [],
            detSelected: null,
            instSelected: {},
            detenteurs: [],
            installations: [],
            fromDetOrInst: false,
            detString: ''

        }

    },
    methods: {

        async sendFormFi() {

            let fi = new Fibsdd;
            let router = this.$router;

            if (_.isEmpty(this.detSelected)) {
                swal('Formulaire incomplet', 'Veuillez sélectionner un détenteur.', 'error');
            } else if (_.isEmpty(this.instSelected)) {
                swal('Formulaire incomplet', 'Veuillez sélectionner une installation.', 'error');
            } else if (
                this.instSelected.hasOwnProperty('fluide') &&
                this.instSelected.fluide !== null &&
                this.instSelected.fluide.id === 44
            ) {
                swal('Fluide non autorisé', "Veuillez remplacer le fluide R-999 de l'installation par un fluide existant.", 'error');
            } else {

                if (!this.fibsdd.numero) {

                    let timestamp = '' + +new Date();
                    this.fibsdd.numero = timestamp.slice(0, -3)

                } else {

                    let fibsdds = fi.getList();
                    let find = _.find(fibsdds, ['numero', this.fibsdd.numero]);

                    if (find !== undefined) {
                        swal('Numero utilisé', 'Vous avez déjà une fiche avec ce numéro', 'warning')
                    }

                }

                fi.addOfflineFibsdd(this.fibsdd).then(data => {
                    router.push({ name: 'fibsdd', params: { id: data } })
                })

            }

        },

        onChange() {

        },

        loadDetenteurs() {
            return new Promise((resolve, reject) => {
                Detenteur.getList().then(data => {
                    let dets = _.sortBy(data, [det => det.raison_sociale.toUpperCase()]);
                    this.detenteurs = dets;

                    this.detenteursOpt = dets.map(det => {
                        let label = det.raison_sociale;
                        label += (det.code_client) ? ' (' + det.code_client + ') - ' : ' - ';
                        label += det.ville + ' / ' + det.code_postal;
                        let value = det.id;

                        return { value, label }
                    });

                    this.detenteursFiltred = this.detenteursOpt.slice(0, 20);
                    this.onSearch('', false);

                    resolve(this.detenteursOpt);

                }).catch(() => {
                    reject('Erreur getDetenteurs')
                })
            })
        },

        onSearch(str) {
            str = this.normalize(str);

            this.detenteursFiltred = this.detenteursOpt.filter(det => {
                if (this.normalize(det.label).includes(str)) { return det }
            }).slice(0, 20)
        },

        normalize(s) {
            let r = s.toLowerCase();

            r = r.replace(new RegExp(/\s/g), "");
            r = r.replace(new RegExp(/[àáâãäå]/g), "a");
            r = r.replace(new RegExp(/æ/g), "ae");
            r = r.replace(new RegExp(/ç/g), "c");
            r = r.replace(new RegExp(/[èéêë]/g), "e");
            r = r.replace(new RegExp(/[ìíîï]/g), "i");
            r = r.replace(new RegExp(/ñ/g), "n");
            r = r.replace(new RegExp(/[òóôõö]/g), "o");
            r = r.replace(new RegExp(/œ/g), "oe");
            r = r.replace(new RegExp(/[ùúûü]/g), "u");
            r = r.replace(new RegExp(/[ýÿ]/g), "y");
            r = r.replace(new RegExp(/\W/g), "");

            return r;
        },

        loadInstallations(val) {
            return new Promise((resolve, reject) => {
                this.fibsdd.detenteur = val.value;
                this.detSelected = _.find(this.detenteurs, ['id', val.value]);

                Installation.getInstallationsForDet(val.value).then(list => {
                    this.installations = _.sortBy(list, [i => i.nom.toUpperCase()]);
                    document.getElementById('choice-install').style.display = "block";
                    this.instSelected = {};
                    return resolve(true);
                }).catch(err => reject(err))
            });
        },

        loadInstallInfos() {
            this.instSelected = _.find(this.installations, ['id', this.fibsdd.installation]);
            if (this.instSelected.fluide !== null) {
                this.fibsdd.charge_init = this.instSelected.charge;
                this.fibsdd.fluide_init = this.instSelected.fluide.id
            }
        },

    },
    mounted: function () {

        if (this.$route.query.num_ot) {
            this.fibsdd.ordre_travail = this.$route.query.num_ot;
        }

        if (this.$route.query.callback) {
            try {
                this.fibsdd.callback = atob(this.$route.query.callback);
            } catch (e) {
                console.error('Erreur lors du décodage du callback:', e);
            }
        }


        this.loadDetenteurs()
            .then(() => {
                if (this.$route.query.detenteur) {
                    this.fromDetOrInst = true;

                    let det;
                    if (_.includes(this.$route.query.detenteur, 'N-')) {
                        det = this.$route.query.detenteur;
                    } else {
                        det = parseInt(this.$route.query.detenteur);
                    }

                    this.fibsdd.detenteur = det;
                    const detObj = _.find(this.detenteurs, ['id', det]);
                    this.detSelected = detObj;

                    let label = detObj.raison_sociale;
                    label += (detObj.code_client) ? ' (' + detObj.code_client + ') - ' : ' - ';
                    label += detObj.ville + ' / ' + detObj.code_postal;
                    this.detString = label;


                    this.loadInstallations({ value: det })
                        .then(() => {
                            if (this.$route.query.installation) {

                                if (_.includes(this.$route.query.installation, 'N-')) {
                                    this.fibsdd.installation = this.$route.query.installation;
                                } else {
                                    this.fibsdd.installation = parseInt(this.$route.query.installation);
                                }

                                this.loadInstallInfos()


                            }
                        })
                        .catch();


                }
            })
            .catch(err => {
            });

    },
    components: {
        vSelect
    }
}
</script>



// WEBPACK FOOTER //
// NewFibsdd.vue?5a5e5af6